module.exports = __webpack_public_path__ + "img/6-fox_v8e_loading.f14e105b.jpg";